/// <amd-module name="Repos/Views/PullRequest/Components/ActivityFeed/ActivityCards/MultiVotesResetCard" />
import * as React from "react";
import * as Resources from "Repos/Views/PullRequest/Resources";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { Components } from "VSS/Platform/Layout";
import { IBasicIdentityRef } from "VSSUI/Persona";
import { Status, Statuses, StatusSize } from "VSSUI/Status";
import { getIdentity, getIdentityComponent, getPropertyValue } from "../Utils/ActivityFeedUtils";
import { ActivityCardSubtle, IActivityCardSharedProps } from "./ActivityCardSubtle";
import { ActivityShimmer } from "./ActivityShimmer";

export const MultiVotesResetCard: React.FunctionComponent<IActivityCardSharedProps> = props => {
    const { isShim } = props;
    if (!isShim) {
        const initiator: IBasicIdentityRef | undefined = getIdentity(
            props.thread,
            getPropertyValue(props.thread, "CodeReviewResetMultipleVotesInitiatorIdentity")
        );

        const numReset = parseInt(getPropertyValue(props.thread, "CodeReviewResetMultipleVotesNumVoters"));
        const reason = getPropertyValue(props.thread, "CodeReviewResetMultipleVotesReason");

        let format;

        if (initiator) {
            format = Resources.ActivityFeedResetMultipleWithInitiator;
        } else if (numReset > 1) {
            format = Resources.ActivityFeedResetMultiple;
        } else {
            format = Resources.ActivityFeedResetSingle;
        }

        const identityIds: string[] = JSON.parse(getPropertyValue(props.thread, "CodeReviewResetMultipleVotesExampleVoterIdentities"));

        const maxIdentitiesShown = numReset > 3 ? 2 : Math.min(3, numReset);

        const identities: JSX.Element[] = [];
        for (let i = 0; i < maxIdentitiesShown; i++) {
            const identity = getIdentity(props.thread, identityIds[i]);
            identity && identities.push(<React.Fragment key={identity.id}>{getIdentityComponent(identity, "margin-horizontal-8")}</React.Fragment>);
        }

        let personaFormat;

        switch (numReset) {
            case 1:
                personaFormat = "{0}";
                break;
            case 2:
                personaFormat = Resources.ActivityFeedTwoIdentities;
                break;
            case 3:
                personaFormat = Resources.ActivityFeedThreeIdentities;
                break;
            default:
                personaFormat = Resources.ActivityFeedFourOrMoreIdentities;
        }

        return (
            <ActivityCardSubtle createDate={props.thread.publishedDate}>
                <Status {...Statuses.Waiting} className="activity-card-first-image" color="neutral" size={StatusSize.l} />
                <FormatComponent elementType={null} format={format}>
                    {initiator && getIdentityComponent(initiator, "margin-right-8")}
                    <FormatComponent elementType={null} format={personaFormat}>
                        {...identities} {(numReset - maxIdentitiesShown).toString()}
                    </FormatComponent>
                </FormatComponent>
                {reason && (
                    <FormatComponent elementType={null} format=": {0}">
                        {reason}
                    </FormatComponent>
                )}
            </ActivityCardSubtle>
        );
    }

    return (
        <ActivityCardSubtle createDate={props.thread.publishedDate}>
            <ActivityShimmer />
        </ActivityCardSubtle>
    );
};

Components.add("ms.vss-code-web.multi-votes-reset-activity-card", MultiVotesResetCard);
